import { ApiPromise } from '@/types';
import { HTTP } from '@/utils';

export interface RecordFormErrorResponse {
  data?: {
    message?: string;
    errors?: Record<string, string[]>;
  };
  success?: {
    title: string;
    message: string;
  };
}

export default class AssessmentRecordFormService {
  static resource = 'tenant/assessments';

  static createRecordForm(assessmentId: number, formData: FormData): ApiPromise {
    return HTTP.post(`${this.resource}/${assessmentId}/record-forms`, formData);
  }

  static updateRecordForm(assessmentId: number, recordFormId: number, formData: FormData): ApiPromise {
    return HTTP.post(`${this.resource}/${assessmentId}/record-forms/${recordFormId}`, formData);
  }

  static deleteRecordForm(id: number): ApiPromise {
    return HTTP.delete(`${this.resource}/record-forms/${id}`);
  }
}
